import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import isEmpty from 'lodash/isEmpty';
import { ActionsButtonsWrapper } from 'components/DecisionTree/DecisionTree.styles';
import SearchPageNextButton from '../DTOrderSearch/Common/SearchPageNextButton/SearchPageNextButton';
import { BackButton } from 'components/common/buttonsComponents';
import {
  Container,
  CustomerDetailsContainer,
  CustomerDetailsFormContainer,
  CustomerDetailsHeaderContainer,
  Title,
  SubTitle,
} from './DTCustomerDetailsFormView.styles';
import { getDecisionNodeAtPath, getCurrentDecisionNodeContent } from 'extractFromState';
import CustomerDetailsInput from './Common/CustomerDetailsInput/CustomerDetailsInput';
import { updateCustomerDetails } from 'actions/tools/CustomerDetailsActions';
import { returnToPreviousMacroWizardPath } from 'actions/searchActions';
import { validate as validateEmail } from 'email-validator';
import { showErrorPopup } from '../../../popups/ErrorPopup/ErrorPopup';

const DTCustomerDetailsFormView = (props) => {
  const { onNextButtonClick } = props;
  const dispatch = useDispatch();
  const content = useSelector(getCurrentDecisionNodeContent);
  const decisionNode = useSelector(getDecisionNodeAtPath);

  const isPhysicalAddressDisabled = decisionNode?.noPhysicalAddress ?? false;
  const [customerDetails, setCustomerDetails] = useState({
    firstName: '',
    lastName: '',
    email: '',
    phoneNumber: '',
    addressLineOne: '',
    addressLineTwo: '',
    city: '',
    state: '',
    zipCode: '',
    country: '',
  });

  const onInputChange = (event) => {
    const { value, name } = event.target;
    setCustomerDetails({ ...customerDetails, [name]: value });
  };

  const isEmailError = !validateEmail(customerDetails.email.trim());

  const isNextButtonActive = () => {
    let customerDetailsConditions = { ...customerDetails };
    if (isPhysicalAddressDisabled) {
      customerDetailsConditions = {
        firstName: customerDetails.firstName,
        lastName: customerDetails.lastName,
        email: customerDetails.email,
        phoneNumber: customerDetails.phoneNumber,
      };
    }

    delete customerDetailsConditions.addressLineTwo;

    return Object.values(customerDetailsConditions).every((customerDetail) => !isEmpty(customerDetail));
  };

  const handleNextButtonClick = () => {
    if (isEmailError) {
      return showErrorPopup(`Please enter a valid email address`, 'Sorry, the email address you provided is incorrect');
    }
    dispatch(updateCustomerDetails({ ...customerDetails, email: customerDetails.email.trim() }));
    onNextButtonClick();
  };

  const handleBackButtonClick = () => dispatch(returnToPreviousMacroWizardPath());

  return (
    <Container>
      <CustomerDetailsHeaderContainer>
        {content?.title && <Title>{content.title}</Title>}
        {content?.subText && <SubTitle>{content.subText}</SubTitle>}
      </CustomerDetailsHeaderContainer>

      <CustomerDetailsContainer>
        <CustomerDetailsFormContainer>
          <CustomerDetailsInput
            name={'firstName'}
            label={'First Name'}
            placeholder={'First Name'}
            onInputChange={onInputChange}
            testId={'firstName'}
          />
          <CustomerDetailsInput
            name={'lastName'}
            label={'Last Name'}
            placeholder={'Last Name'}
            onInputChange={onInputChange}
          />
          <CustomerDetailsInput name={'email'} label={'Email'} placeholder={'Email'} onInputChange={onInputChange} />
          <CustomerDetailsInput
            name={'phoneNumber'}
            label={'Phone Number'}
            placeholder={'Phone Number'}
            onInputChange={onInputChange}
          />
          <CustomerDetailsInput
            name={'addressLineOne'}
            label={'Address Line 1'}
            placeholder={isPhysicalAddressDisabled ? '' : 'Address Line 1'}
            onInputChange={onInputChange}
            disabled={isPhysicalAddressDisabled}
          />
          <CustomerDetailsInput
            name={'addressLineTwo'}
            label={'Address Line 2'}
            placeholder={isPhysicalAddressDisabled ? '' : 'Address Line 2'}
            onInputChange={onInputChange}
            disabled={isPhysicalAddressDisabled}
          />
          <CustomerDetailsInput
            name={'city'}
            label={'City'}
            placeholder={isPhysicalAddressDisabled ? '' : 'City'}
            onInputChange={onInputChange}
            disabled={isPhysicalAddressDisabled}
          />
          <CustomerDetailsInput
            name={'state'}
            label={'State'}
            placeholder={isPhysicalAddressDisabled ? '' : 'State'}
            onInputChange={onInputChange}
            disabled={isPhysicalAddressDisabled}
          />
          <CustomerDetailsInput
            name={'zipCode'}
            label={'Zip Code'}
            placeholder={isPhysicalAddressDisabled ? '' : 'Zip Code'}
            onInputChange={onInputChange}
            disabled={isPhysicalAddressDisabled}
          />
          <CustomerDetailsInput
            name={'country'}
            label={'Country'}
            placeholder={isPhysicalAddressDisabled ? '' : 'Country'}
            onInputChange={onInputChange}
            disabled={isPhysicalAddressDisabled}
          />
        </CustomerDetailsFormContainer>
      </CustomerDetailsContainer>

      <ActionsButtonsWrapper>
        <SearchPageNextButton
          active={isNextButtonActive()}
          disabled={!isNextButtonActive()}
          type="submit"
          onClick={handleNextButtonClick}
        >
          NEXT
        </SearchPageNextButton>
        <BackButton onClick={handleBackButtonClick}>BACK</BackButton>
      </ActionsButtonsWrapper>
    </Container>
  );
};

export default DTCustomerDetailsFormView;
